
'use strict';

angular.module('betosyswebapp')
.service('stateManagerService', function ($log,AuthenticationService){

var stateData = {};

this.updateDeviceID = function (widgetName, value, updateGlobal){

    this.updateValue(widgetName, 'deviceID' , value, updateGlobal);
};

this.updateStartDate = function (widgetName, value, updateGlobal){

    this.updateValue(widgetName, 'startDate' , value, updateGlobal);
};

this.updateEndDate = function (widgetName, value, updateGlobal){

    this.updateValue(widgetName, 'endDate' , value, updateGlobal);
};

this.updateGlobalValue = function(valueType, value){
    var date = new Date().getTime();

    if(!stateData.global){
        stateData.global = {};
    }

    stateData.global[valueType] = {
        value : value,
        timestamp : date
    };

    stateData.global.timestamp = date;
};

this.updateValue = function(widgetName, valueType, value, updateGlobal){
  var loginID = AuthenticationService.GetLoginID();
  widgetName = loginID.Account + '_' + loginID.username + '_' + widgetName;
    if(!stateData[widgetName]){
        stateData[widgetName] = {};
    }

    var date = new Date().getTime();

    stateData[widgetName][valueType] = {
        value : value,
        timestamp : date
    };

    stateData[widgetName].timestamp = date;

    if( updateGlobal === true){
        if(!stateData.global){
            stateData.global = {};
        }
        stateData.global[valueType] = {
            value : value,
            timestamp : date
        };
        stateData.global.timestamp = date;
    }
};

this.log = function(data){
    $log.info(data);
};

this.getStateData = function(){
    return stateData;
};

this.getGlobalStateData = function(){

    if(!stateData.global){
        stateData.global = {};
    }
    return stateData.global;
};

});



// WEBPACK FOOTER //
// ./.tmp/components/common/services/stateManagerService.js